import Box from '@mui/material/Box';
import microsoftLogo from './window.svg';

const MicrosoftLogo = props => <Box component="img" alt="" src={microsoftLogo} style={{ height: '100%' }} {...props} />;

export default MicrosoftLogo;
